export const baseDenom = "uscrt";
export const geckoUrl = `https://api.coingecko.com/api/v3/simple/price`;

export const defaultGas = {
  native_swap: "625000",
  snip_swap: "655000",
  add_liquidity: "495000",
  remove_liquidity: "455000",
  bond_liquidity: "395000",
  unbond_liquidity: "395000",
  ibc_deposit: "95000",
  ibc_withdraw: "95000",
  snip_transfer: "55000",
  snip_send: "75000",
  snip_allowance: "55000",
  create_viewing_key: "55000",
  native_transfer: "25000",
  claim_rewards: "450000",
  wrap_token: "125000",
  unwrap_token: "125000",
};

// export const testnetMintscanPrefix =
//   "https://testnet.mintscan.io/secret-testnet/txs/";
export const testnetMintscanPrefix =
  "https://secretnodes.com/pulsar/transactions/";

// export const mainnetMintscanPrefix = "https://mintscan.io/secret/txs/";
export const mainnetMintscanPrefix = "https://secretnodes.com/secret/transactions/";

export const networkType = "mainnet"; // "mainnet" or "testnet"

export const sleepTime = 0.05; // number of seconds
